import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { mockTips } from '../mock';

export const TipsSection = () => {
  return (
    <section id="dicas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A2540] mb-4">
            Dicas de Transporte
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Informações essenciais para garantir o sucesso do seu transporte
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTips.map((tip) => (
            <Card 
              key={tip.id} 
              className="hover:shadow-xl transition-all duration-300 border-2 hover:border-[#F4D03F]"
            >
              <CardHeader>
                <Badge className="w-fit mb-3 bg-[#8B3A9C] hover:bg-[#8B3A9C]">
                  {tip.category}
                </Badge>
                <CardTitle className="text-lg text-[#0A2540]">
                  {tip.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-gray-600 leading-relaxed">
                  {tip.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
